export default __webpack_public_path__ + "static/media/LM_Car_Lora_Thumb.bfe87d7c.jpg";